import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'cityads-v3/types/reducer';
import { makeRequest } from 'cityads-v3/utils/apiUtils';
import { flatten } from 'lodash';

interface SadukaCreateDomainError {
  response?: {
    data?: {
      form_errors?: {
        [key: string]: string[]
      }
    }
  }
}

export const slice = createSlice({
  name: 'domainParking',
  initialState: {
    createFormError: false,
    createFormEntityErrors: [] as string[]
  },
  reducers: {
    createDomainParking: (state, action) => {
      state.createFormError = false;
      state.createFormEntityErrors = [];
    },

    createDomainParkingSuccess: (state, action) => {
      state.createFormError = false;
      state.createFormEntityErrors = [];
    },

    createDomainParkingFail: (state, action) => {
      state.createFormError = true;
      state.createFormEntityErrors = flatten(
        Object.values(
          (action as SadukaCreateDomainError)?.response?.data?.form_errors ?? {}
        )
      ) ?? [];
    },

    resetCreateFormState: (state, action) => {
      state.createFormError = false
      state.createFormEntityErrors = []
    },

    deleteDomain: (state, action) => { },
    deleteDomainSuccess: (state, action) => { },
    deleteDomainFail: (state, action) => { },

  }
})

export const {
  createDomainParking,
  createDomainParkingSuccess,
  createDomainParkingFail,

  deleteDomain,
  deleteDomainSuccess,
  deleteDomainFail,

  resetCreateFormState
} = slice.actions;

export const selectCreateFormError = (state: RootState) => state.domainParking?.createFormError
export const selectCreateFormEntityErrors = (state: RootState) => state.domainParking.createFormEntityErrors

export function createDomain(domain: string, comment: string, domainType: number) {
  return makeRequest(`/saduka/parkedDomains`, {
    types: [createDomainParking.type, createDomainParkingSuccess.type, createDomainParkingFail.type],
    options: {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        parkedDomain: {
          name: domain,
          comment,
          type: domainType,
        }
      })
    },
  })
}

export function deleteDomainAction(id: number) {
  return makeRequest(`/saduka/parkedDomains/${id}`, {
    types: [deleteDomain.type, deleteDomainSuccess.type, deleteDomainFail.type],
    options: {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
    },
  })
}

export default slice.reducer
